const skydropxRateModeEnum = Object.freeze({
    AUTO_MIN: 1,
    CUSTOMER_SELECT: 2,
});

export default skydropxRateModeEnum;
